import type { MessageFormValues } from '@/app/KeywordTracker/types/aiModalTypes';
import { successMessage } from '@/utils/toast';
import { Formik } from 'formik';
import { IoSend } from 'react-icons/io5';
import { Button, Form, Spinner } from 'react-bootstrap';
import TextareaAutosize from 'react-textarea-autosize';
import * as yup from 'yup';

interface AiModalMessageFormProps {
  isRTL: boolean;
  isSendingMessage: boolean;
  onSendMessage: (message: string) => Promise<unknown>;
}

const AiModalMessageForm = ({
  isRTL,
  isSendingMessage,
  onSendMessage
}: AiModalMessageFormProps) => {
  return (
    <Formik<MessageFormValues>
      onSubmit={(values, actions) => {
        const messageText = values.message.trim();

        onSendMessage(messageText).then(() => {
          successMessage('پیام ارسال شد.');
          actions.resetForm();
        });
      }}
      validationSchema={yup.object().shape({
        message: yup
          .string()
          .trim()
          .required('پیام رو وارد نکردید.')
          .max(500, 'حداکثر ۵۰۰ کاراکتر مجاز است.')
      })}
      initialValues={{ message: '' }}
    >
      {({ values, handleChange, handleSubmit }) => (
        <Form
          dir="ltr"
          style={{ maxHeight: '600px' }}
          className={`mt-auto chat-editor-area m-auto fs-2`}
          onSubmit={e => {
            e.preventDefault();
            handleSubmit();
          }}
        >
          <div dir="rtl" className="d-flex w-100">
            <TextareaAutosize
              dir={isRTL ? 'rtl' : 'ltr'}
              minRows={1}
              maxRows={6}
              name="message"
              id="message"
              onKeyDown={e => {
                if (e.key === 'Enter' && !e.shiftKey) {
                  e.preventDefault();
                  handleSubmit();
                }
              }}
              value={values.message}
              placeholder="پیام خود را وارد کنید"
              onChange={handleChange}
              className="message-input form-control outline-none resize-none rounded-0 border-0 emojiarea-editor px-2 py-3"
              style={{ fontSize: '16px' }}
            />

            <Button
              variant="falcon-primary"
              size="lg"
              type="submit"
              className="m-2 d-flex align-items-center justify-content-center align-self-end"
              style={{
                width: '40px',
                height: '40px',
                borderRadius: '50%',
                padding: 0,
                transform: 'scale(-1,-1)'
              }}
              disabled={isSendingMessage}
            >
              {isSendingMessage ? (
                <Spinner style={{ width: '20px', height: '20px' }} />
              ) : (
                <IoSend
                  style={{
                    fontSize: '1.2rem',
                    marginRight: '-3px',
                    color: 'white',
                    width: '40px'
                  }}
                />
              )}
            </Button>
          </div>
        </Form>
      )}
    </Formik>
  );
};

export default AiModalMessageForm;
